export type ClassColor = [number, number, number, number];

export type Classification = {
  identifier: string;
  name: string;
  code: number;
  color: ClassColor;
  custom: boolean;
};

export const ClassificationScheme = [
  { code: 0, custom: false, name: 'neverClassified', color: [0.5, 0.5, 0.5, 1.0] },
  { code: 1, custom: false, name: 'unclassified', color: [0.5, 0.5, 0.5, 1.0] },
  { code: 2, custom: false, name: 'ground', color: [0.63, 0.32, 0.18, 1.0] },
  { code: 3, custom: false, name: 'lowVegetation', color: [0.0, 1.0, 0.0, 1.0] },
  { code: 4, custom: false, name: 'mediumVegetation', color: [0.0, 0.8, 0.0, 1.0] },
  { code: 5, custom: false, name: 'highVegetation', color: [0.0, 0.6, 0.0, 1.0] },
  { code: 6, custom: false, name: 'building', color: [1.0, 0.66, 0.0, 1.0] },
  { code: 7, custom: false, name: 'lowPointNoise', color: [1.0, 0.0, 1.0, 1.0] },
  { code: 8, custom: false, name: 'keyPoint', color: [1.0, 0.0, 0.0, 1.0] },
  { code: 9, custom: false, name: 'water', color: [0.0, 0.0, 1.0, 1.0] },
  { code: 10, custom: false, name: 'rail', color: [0.01, 0.01, 0.01, 1.0] },
  { code: 11, custom: false, name: 'roadSurface', color: [1.0, 0.63, 0.48, 1.0] },
  { code: 12, custom: false, name: 'overlap', color: [1.0, 1.0, 0.0, 1.0] },
  { code: 13, custom: false, name: 'wireGuard', color: [0.0, 0.75, 1.0, 1.0] },
  { code: 14, custom: false, name: 'wireConductor', color: [0.0, 0.5, 0.5, 1.0] },
  { code: 15, custom: false, name: 'transmissionTower', color: [0.28, 0.24, 0.55, 1.0] },
  { code: 16, custom: false, name: 'wireStructureConnector', color: [0.0, 0.0, 0.5, 1.0] },
  { code: 17, custom: false, name: 'bridgeDeck', color: [0.94, 0.9, 0.55, 1.0] },
  { code: 18, custom: false, name: 'highNoise', color: [1.0, 0.08, 0.58, 1.0] },
  { code: 19, custom: false, name: 'overheadStructure', color: [0.73, 0.33, 0.83, 1.0] },
  { code: 20, custom: false, name: 'ignoredGround', color: [0.86, 0.44, 0.58, 1.0] },
  { code: 21, custom: false, name: 'snow', color: [1.0, 1.0, 1.0, 1.0] },
  { code: 22, custom: false, name: 'temporalExclusion', color: [1.0, 0.27, 0.0, 1.0] },
] as Classification[];
